import ScheduleInternalTransactionViewSchedule from "../../../containers/ScheduleInternalTransaction/ScheduleInternalTransactionViewSchedule";
import "./index.css";
import IconRoundButton from "../../_utils/CommonButtons/IconRoundButton";

const ScheduleInternalTxnHistroy = ({
  onClose,
  isConf,
  txnHistorytype,
  destination_account_number,
  source_account_number,
  owner_account_id,
  internal_account_id,
  setShowScheduleTxnPopup,
  title,
  type,
  subtitle,
  payload,
}) => {
  return (
    <>
      <div
        style={{ zIndex: "var(--max-zindex)" }}
        className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity"
      >
        <div
          className="fixed top-top-base left-left-base w-full h-screen z-z-index-modal bg-opacity-dark-opacity"
          style={{ backgroundColor: "var(--Primary-black)" }}
        ></div>
        <div
          style={{ backgroundColor: "var(--primary-bg)" }}
          className="main_pop_div relative animate-none Qmd:animate-slideInFromRight"
        >
          <div className="Qmd:absolute top-top-base bg-primary-bg z-z-index-modal p-padding-md left-left-base hidden Qmd:flex justify-between items-center w-full">
            <div className="flex flex-col gap-y-gap-xs">
              <p className="text-font-md text-text-primary font-semibold font-sans">
                {isConf
                  ? "Confidential transaction"
                  : type === "scheduleInternalAcc"
                    ? title
                    : "Schedule history"}
              </p>
              <p className="text-font-xs text-text-primary font-normal font-sans">
                {type === "scheduleInternalAcc"
                  ? subtitle
                  : "All scheduled transaction related to internal are listed below."}
              </p>
            </div>

            <IconRoundButton
              enabledBgColor={"var(--primary-nav)"}
              isLoading={false}
              handleFunction={() => {
                if (type === "scheduleInternalAcc") {
                  setShowScheduleTxnPopup(false);
                  onClose();
                } else {
                  onClose();
                }
              }}
              icon={"https://q2pay.in/new_assets/common/create_flow/close.svg"}
              hoverOption={"white"}
              btnType={"button"}
              title={"Close"}
              disabledBgColor={""}
            />
          </div>
          <ScheduleInternalTransactionViewSchedule
            onClose={onClose}
            txnHistorytype={txnHistorytype}
            destination_account_number={destination_account_number}
            source_account_number={source_account_number}
            owner_account_id={owner_account_id}
            internal_account_id={internal_account_id}
            isConf={isConf}
            title={title}
            type={type}
            payload={payload}
          />
        </div>
      </div>
    </>
  );
};

export default ScheduleInternalTxnHistroy;
